import api from "./client";

export function getQueue(status = "submitted") {
  return api.get(`/documents/queue?status=${status}`);
}

export function approveDocument(id) {
  return api.post(`/documents/${id}/approve`);
}

export function releaseDocument(id) {
  return api.post(`/documents/${id}/release`);
}

export function rejectDocument(id, rejection_reason) {
  return api.post(`/documents/${id}/reject`, { rejection_reason });
}

export function uploadDocument(formData) {
  return api.post("/documents/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export function getAttorneyDocuments() {
  return api.get("/attorney/documents");
}

export function viewAttorneyDocument(id) {
  return api.get(`/attorney/documents/${id}/view`, { responseType: "blob" });
}
